<template>
    <BaseField class="stretch" v-bind="$props" v-on="$listeners">
        <CountryTagsDropdown
            class="value-field"
            :selectedIds="value"
            :countriesData="countriesData"
            @itemSelected="itemSelected"
            @itemDeselected="itemDeselected"
        />
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';
import CountryTagsDropdown from 'components/dropdowns/CountryTagsDropdown.vue';

export default {
    name: 'CountryField',
    components: { CountryTagsDropdown, BaseField },
    props: {
        ...BaseField.props,
        value: Array,
        countriesData: Object
    },
    methods: {
        itemSelected(option) {
            const value = this.value || [];
            this.updateValue([...value, option.id]);
        },
        itemDeselected(option) {
            const value = this.value || [];
            this.updateValue(value.filter((item) => item !== option.id));
        },
        updateValue(value) {
            this.$emit('update:value', value);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/input.scss";

.value-field {
    width: 100%;
    max-width: 370px;
}
</style>
